import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { isValidElement, useMemo } from 'react';

import Card from 'src/shared/components/card/card';

import styles from './drilling-element-card.module.scss';

interface Props {
  title: ReactNode;
  icon?: ReactNode;
  description?: ReactNode;
  className?: string;
  isCompactView?: boolean;
}

export const DrillingElementCard = observer(function DrillingElementCard({
  title,
  icon,
  description,
  className,
  isCompactView,
}: Props) {
  const header = useMemo(() => {
    if (isCompactView) {
      return (
        <>
          <h3 className={styles.cardHeader}>{title}</h3>
          {isValidElement(description) && description}
        </>
      );
    }

    return <h3 className={styles.cardHeader}>{title}</h3>;
  }, [title, description, isCompactView]);

  return (
    <Card icon={icon} header={header} className={clsx(className, styles.card)} isCompactView={isCompactView}>
      {!isCompactView && isValidElement(description) && <div className={styles.cardDescription}>{description}</div>}
    </Card>
  );
});
